<template>
    <div class="parts-player__nav">
        <div
            class="parts-player__pages"
            :class="{
                'parts-player__pages--embed': isEmbed,
                'parts-player__pages--reviewer-embed': hideRibbon
            }"
        >
            {{
                $t(hideRibbon ? 'partsPlayer.lengthReviewer' : 'partsPlayer.length', {
                    cur: currentSentence,
                    size: sentences.length,
                    page,
                    total: totalPages
                })
            }}
            <span v-if="approximateDuration" class="parts-player__pages-duration">
                <span v-if="hideRibbon" class="parts-player__pages-divider" />
                <template v-else>&nbsp; | &nbsp;</template>
                {{ approximateDuration }}
            </span>
        </div>
        <div v-if="!hideRibbon" class="parts-player__nav-inner">
            <div class="parts-player__sentences">
                <template v-for="(sentence, index) in sentences" :key="sentence.id">
                    <li class="parts-player__sentence">
                        <button
                            v-tooltip="cutText(sentence.raw_text, 30)"
                            class="parts-player__nav-button"
                            :class="{
                                'is-active': hoveredIndex
                                    ? index < hoveredIndex
                                    : sentence.partIndex < activePart.partIndex
                            }"
                            type="button"
                            @mouseenter="hoveredIndex = index"
                            @mouseleave="hoveredIndex = null"
                            @click="
                                selectPart({
                                    partId: sentence.id
                                })
                            "
                        />
                    </li>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import cutText from '@speechki-frontend/shared/helpers/functions/cutText';
import { mapGetters } from 'vuex';

const formatDuration = (seconds, locale) => {
    let secondsNum = parseInt(seconds, 10);
    let _hours = Math.floor(secondsNum / 3600);
    let _minutes = Math.floor(secondsNum / 60) % 60;
    let _seconds = secondsNum % 60;

    let arr = [_hours, _minutes, _seconds].map(v => (v < 10 ? '0' + v : v));
    return `${arr[0]} ${locale === 'eng' ? 'h' : 'ч'} ${arr[1]} ${locale === 'eng' ? 'm' : 'м'} ${
        arr[2]
    } ${locale === 'eng' ? 'c' : 'с'}`;
};

const restrictedTextTypes = ['pause', 'audio', 'paragraph_end'];
const restrictecPlayerTypes = ['pause', 'bump'];

export default {
    name: 'PartsPlayerNav',
    props: {
        parts: {
            type: Array,
            required: true
        },
        activePart: {
            type: Object,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
        isEmbed: {
            type: Boolean,
            default: false
        },
        // Professional Prooflistening (embedded outsourced reviewer):
        // hides only the sentence tick-mark ribbon (.parts-player__nav-inner),
        // which has no equivalent in the design mock. The "Page X/Y" +
        // remaining-time badge (.parts-player__pages) stays visible and gets
        // restyled to match the mock's floating pill in that same case.
        hideRibbon: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hoveredIndex: null,

            currentSentence: 1
        };
    },

    computed: {
        ...mapGetters(['bookApproximateDuration']),
        sentences() {
            if (!this.parts.length) return [];

            return this.parts
                .map((part, index) => ({
                    ...part,
                    partIndex: index
                }))
                .filter(part => {
                    if (restrictedTextTypes.includes(part.type_part.slug)) return false;

                    return true;
                });
        },
        approximateDuration() {
            if (!this.bookApproximateDuration) return '';

            return formatDuration(this.bookApproximateDuration, this.$i18n.locale);
        }
    },

    watch: {
        activePart: {
            immidiate: true,
            handler() {
                if (restrictecPlayerTypes.includes(this.activePart.type)) return;

                const index = this.sentences.findIndex(s => this.activePart.partId === s.id);

                this.currentSentence = index + 1;
            }
        }
    },

    methods: {
        cutText,
        showPart(part) {
            return !restrictedTextTypes.includes(part.type_part.slug);
        },
        selectPart(event) {
            this.$emit('select', event);
        }
    }
};
</script>
